import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { hideLoader, showLoader, addFlashMessage } from '../../../actions';
import { connect } from 'react-redux'
import to from 'await-catch'
import { getRoles } from '../../../api';

function Roles() {
	const [roles, setRoles] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                showLoader()
                const [err, [{ data } = {}]] = await to([
                    getRoles(),
                ])

                if (err)
                    throw new Error("Error en el fetch de roles");

                setRoles(data.items);
            } catch (error) {
                addFlashMessage("Ocurrió un error cargando los roles");
            }
            finally {
                hideLoader()
            }
        };

        fetchData();
    }, []);

	return (
		<RoleGrid>
		{roles.map(role => (
				<RoleCard key={role.idRol}>
				<RoleTitle>{role.nombre}</RoleTitle>
				<RoleDescription>
					{role.descripcion}
				</RoleDescription>
				<RoleType>Tipo: {role.clave}</RoleType>
			</RoleCard>
		))}
		</RoleGrid>
	)
}

export const RoleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  width: 100%;

  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    grid-template-columns: 1fr;
  }
`

export const RoleCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 24px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;

  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    width: 100%;
    max-width: 100%;
  }
`

export const RoleTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.text.primaryText};
`

export const RoleDescription = styled.p`
  margin: 0;
  font-size: 16px;
color: ${props => props.theme.colors.text.secondaryText};
`

export const RoleType = styled.span`
  margin-top: 8px;
  font-size: 16px;
  color: ${props => props.theme.colors.text.secondaryText};
`

const mapDispatchToProps = {
	showLoader,
	hideLoader,
	addFlashMessage
}

export default connect(null, mapDispatchToProps)(Roles)
